import type { MetaLocatorDropdownItem } from "./LayoutMetalocator"

export const getDropdownValues = (
  dropdownItems: MetaLocatorDropdownItem[],
): string[] => {
  return dropdownItems.map(item => item.displayValue)
}

export const getDependentDropdownValues = (
  industryDropDowns: MetaLocatorDropdownItem[],
  selectedIndustry: string,
): string[] => {
  const industry = industryDropDowns.find(
    item => item.displayValue === selectedIndustry,
  )
  return industry?.dependentDropDowns?.map(item => item.displayValue) || []
}

export const getSelectedItem = (
  industryDropDowns: MetaLocatorDropdownItem[],
  selectedIndustry: string,
  selectedCategory: string,
  categoryDropDownValues: string[],
): MetaLocatorDropdownItem | null => {
  if (selectedCategory) {
    const industry = industryDropDowns.find(
      item => item.displayValue === selectedIndustry,
    )
    return (
      industry?.dependentDropDowns?.find(
        item => item.displayValue === selectedCategory,
      ) || null
    )
  } else if (selectedIndustry && categoryDropDownValues.length === 0) {
    return (
      industryDropDowns.find(item => item.displayValue === selectedIndustry) ||
      null
    )
  }
  return null
}

export const getMetaLocatorUrl = (
  instanceId: string,
  metaLocatorLanguage?: string,
  tagIds?: string[],
): string => {
  const baseUrl = instanceId.startsWith("http")
    ? instanceId
    : `https://code.metalocator.com/index.php?option=com_locator&view=directory&layout=combined_bootstrap&Itemid=${instanceId}&tmpl=component&framed=1${
        metaLocatorLanguage ? `&lang=${metaLocatorLanguage}` : ""
      }`

  const validTags = tagIds?.filter(Boolean) ?? []
  if (validTags.length === 0) return baseUrl

  // Preselect/filter by specialty tag(s). MetaLocator applies this on load only
  // when a search task is triggered, so we mirror the interface's own "Filter"
  // submission: one tags[] entry per id plus task=search_zip.
  const params = new URLSearchParams()
  validTags.forEach(id => params.append("tags[]", id))
  params.set("task", "search_zip")

  return `${baseUrl}${baseUrl.includes("?") ? "&" : "?"}${params}`
}
